
import Vue from 'vue';
import { Icon } from '@descomplica/vue-components';

export default Vue.extend({
  components: {
    Icon,
  },
  props: {
    progress: {
      type: Number,
      required: true,
    },
    hiddenLabel: {
      type: Boolean,
      default: false,
    },
    labelInBottom: {
      type: Boolean,
      default: false,
    },
    labelIsBlack: {
      type: Boolean,
      default: false,
    },
    isThin: {
      type: Boolean,
      default: false,
    },
    isRounded: {
      type: Boolean,
      default: false,
    },
    isIncorretProgress: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    completed(): Boolean {
      return this.progress === 100;
    },
  },
});
